import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "report",
  style: {"width":"100%","height":"calc(100vh - 64px - 52px)","min-height":"400px","overflow-y":"auto","overflow-x":"auto","font-size":"8pt","padding":"24px"},
  class: "scrollbar-hidden"
}
const _hoisted_2 = ["id", "viewBox"]
const _hoisted_3 = {
  key: 0,
  id: "dashboard-report"
}
const _hoisted_4 = ["x", "y", "width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxComponent = _resolveComponent("BoxComponent")!

  return (_ctx.report)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.elements, (reportElement) => {
          return (_openBlock(), _createElementBlock("svg", {
            key: reportElement.id,
            id: reportElement.id,
            ref_for: true,
            ref: "svg",
            class: "designer-container designer-layout report-element",
            width: "100%",
            height: "100%",
            viewBox: `0 0 ${_ctx.report.elementWidth} ${_ctx.report.elementHeight}`,
            preserveAspectRatio: "xMidYMid meet"
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("defs", null, [
              _createElementVNode("filter", { id: "shadow" }, [
                _createElementVNode("feDropShadow", {
                  dx: "0",
                  dy: "0",
                  stdDeviation: "0.5"
                })
              ])
            ], -1)),
            (_ctx.isDashboardReport)
              ? (_openBlock(), _createElementBlock("g", _hoisted_3, [
                  _createElementVNode("rect", {
                    fill: '#ffffff',
                    style: {"filter":"url(\"#shadow\")"},
                    x: _ctx.dashboardReportElement.x,
                    y: _ctx.dashboardReportElement.y,
                    width: _ctx.dashboardReportElement.width,
                    height: _ctx.dashboardReportElement.height,
                    stroke: 'grey',
                    "stoke-width": "1"
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("g", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportElement.children, (box) => {
                return (_openBlock(), _createBlock(_component_BoxComponent, {
                  key: box.id,
                  box: box,
                  viewType: "REPORT",
                  selectedBoxObj: _ctx.selectedBox,
                  hideMenuOptions: _ctx.hiddenObjectsMenuOptions,
                  onSelectedBox: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelectedBox($event))),
                  ref_for: true,
                  ref: "reportBoxComponent"
                }, null, 8, ["box", "selectedBoxObj", "hideMenuOptions"]))
              }), 128))
            ])
          ], 8, _hoisted_2))
        }), 128))
      ], 512))
    : _createCommentVNode("", true)
}